/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { useEffect, useState } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import * as util from "../app/popleads/app/functions/util";
import { getCallbackTarget, postTokenToCallback } from "./modules/Auth/crmCallback";
// import { RepeatRounded } from "@material-ui/icons";
import EvaluationFormReport from "./popleads/modules/pdf/EvaluationFormReport";
import FinalReport from "./popleads/modules/pdf/FinalReport/FinalReport";
import ExtensionHome from "./popleads/modules/extension/ExtensionHome";

let count = 0;
export function Routes() {
    const [isUserLoaded, setUserLoaded] = useState(0);

    const { isAuthorized } = useSelector(
        ({ auth }) => ({
            isAuthorized: auth.user.name !== "",
        }),
        shallowEqual
    );
    //PopLeads change
    let authToken = util.getCookieValue(util.getCookieName());
    if (!authToken) {
        authToken = util.getUrlQueryParam("sid");
        if (authToken) util.createCookie(util.getCookieName(), authToken, 14);
    }

    if (authToken && count == 0) {
        setUserLoaded(true);
        count++;
    }

    if (!authToken && count == 0) {
        setUserLoaded(true);
        count++;
    }

    const pathname = window.location.pathname;

    // Already signed in on /auth/login?redirect=…: hand the session to the callback without showing the form.
    const searchParams = new URLSearchParams(window.location.search);
    const callbackTarget =
        authToken && pathname.startsWith("/auth/login") ? getCallbackTarget(searchParams.get("redirect")) : null;
    const callbackState = searchParams.get("state");

    useEffect(() => {
        if (callbackTarget) postTokenToCallback(callbackTarget, authToken, callbackState);
    }, [callbackTarget, authToken, callbackState]);

    if (!(isAuthorized || authToken)) {
        if (
            pathname !== "/" &&
            pathname !== "/logout" &&
            !pathname.startsWith("/auth") &&
            !pathname.startsWith("/error")
        ) {
            localStorage.setItem("prevUrl", window.location.pathname + window.location.search);
        } else {
            if (!localStorage.getItem("prevUrl")?.includes("/extension")) {
                localStorage.removeItem("prevUrl");
            }
        }
    }

    //if(authToken) setUserLoaded(true);
    if (!isUserLoaded || callbackTarget) {
        return <div></div>;
    }

    return (
        <Switch>
            {!(isAuthorized || authToken) ? ( //PopLeads change
                /*Render auth page when user at `/auth` and not authorized.*/
                <Route>
                    <AuthPage />
                </Route>
            ) : (
                /*Otherwise redirect to root page (`/`)*/
                <Redirect from="/auth" to="/" />
            )}

            <Route path="/error" component={ErrorsPage} />
            <Route path="/extension" component={ExtensionHome} />
            <Route path="/logout" component={Logout} />

            <Route path="/pdf/evaluation-report" component={EvaluationFormReport} />
            <Route path="/pdf/final-report" component={FinalReport} />

            {!(isAuthorized || authToken) ? ( //PopLeads change
                /*Redirect to `/auth` when user is not authorized*/
                <Redirect to="/auth/login" />
            ) : (
                <Layout>
                    <BasePage />
                </Layout>
            )}
        </Switch>
    );
}
